export const prologueSecondDialogues: any[] = [
    {
        id: 1,
        dialogue: [
            `
            Emily: Dad, are we almost there?
            <
            Alex: Not yet, sweetheart. Havenwood is still a few hours away. But hey, think of all the fun we'll have once we get there.
            <
            Emily: I can't wait! I haven't seen grandma in a while.. I've missed her a lot..
            `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 2 }],
    },
    {
        id: 2,
        dialogue: [
            `
            *Car engine starts to make a rumbling noise*
            <
            Alex: What..?
            <
            That's weird.. there seems to be something wrong with the engine.. 
            <
            Alright, let me take a look under the hood and see what's going on.
            <
            Emily: Is something wrong with the car, Dad?
            <
            Alex: Just a little hiccup probably, Em. Nothing we can't handle. Just stay here and rest a bit okay?
            <
            Emily: Alright dad..
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 2 }],
    },
    {
        id: 3,
        dialogue: [
            `
            *Steps out of the car and pops the hood*
            <
            Alex: Well.. lets see what we got here..
        `,
        ],
        options: [{ id: 1, action: "Look inside the hood", roomId: 2 }],
    },
    {
        id: 4,
        dialogue: [
            `
            As you look around the engine and you notice some kind of liquid spilled around the oil fill insertion pipe.
            <
            Alex: What the hell.. what is this?..
            <
            Wait.. i have seen this before.. 
            <
            and this smell.. is that?..
            <
            Sugar water?..
            <
            Why is it all over the engine?..
            <
            Someone must have done this.. but why?..
            <
            You hear Emily screaming to you from inside the car but you can't quite hear what she's saying.
        `,
        ],
        options: [{ id: 1, action: "Close the open hood", roomId: 2 }],
    },
    {
        id: 5,
        dialogue: [
            `
            As you close you the hood you see Emily pointing towards you.
            <
            Alex: Honey what's wrong?..
            <
            Emily: DAD!.. DAD!..
            <
            You see Emily in complete panic
            <
            Emily: DAD!.. Behind y...
            <
            *Black out*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 2 }],
    },
    {
        id: 6,
        dialogue: [
            `
            As you close you the hood you see Emily pointing towards you.
            <
            Alex: Honey what's wrong?..
            <
            Emily: DAD!.. DAD!..
            <
            You see Emily in complete panic
            <
            Emily: DAD!.. Behind y...
            <
            *Black out*
        `,
        ],
        options: [{ id: 1, action: "Restart scene..", roomId: 2 }],
    },
    {
        id: 99,
        dialogue: [
            `
            Bathroom first dialogue
        `,
        ],
        options: [{}],
    },
];

export const introduction: string = `
Welcome to "Into the Shadows", a gripping narrative text-based adventure game where you take on the role of Alex, 

a 34-year-old man, on a journey with his daughter, Emily. After a rough divorce, Alex and Emily look to reconnect with one another by going on a road trip visiting Alex's parents in the town called Havenwood.

During the adventure you'll unravel mysteries, confront past mistakes, and navigate challenges that test the strength of your bond. Get ready for an immersive experience where every choice matters as you delve into the shadows of Alex's past. Are you prepared to face what lies ahead?
`;
